import React from 'react'
import Screen from 'containers/Screen'
import PromocaoBox from 'components/PosCNU2025/PosCNU2025'

export default function PosCNU2025Screen () {
  return (
    <Screen title={''}>
      <PromocaoBox />
    </Screen>
  )
}
